import {Api} from 'common/Api';

const request_path = "/?rest_route=/affinipay/v1/charge";

export default class PaymentApi extends Api {

  public charge(content: any): Promise<any>  {
    return this.post(request_path, content)
  }
}


// WEBPACK FOOTER //
// ./src/checkout/PaymentApi.tsx